"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVirtual = useVirtual;

var _reactVirtual = require("@tanstack/react-virtual");

var _react = require("react");

/**
 * SPDX-FileCopyrightText: © 2023 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function useVirtual(_ref) {
  var _estimateSize = _ref.estimateSize,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      parentRef = _ref.parentRef;
  var virtualizer = (0, _reactVirtual.useVirtualizer)({
    count: items.length,
    estimateSize: function estimateSize() {
      return _estimateSize;
    },
    getScrollElement: function getScrollElement() {
      return parentRef.current;
    },
    overscan: 7
  });
  var previousLengthRef = (0, _react.useRef)(items.length);
  (0, _react.useEffect)(function () {
    if (items.length < previousLengthRef.current && items.length > 0) {
      virtualizer.scrollToIndex(0, {
        behavior: 'auto'
      });
    }

    previousLengthRef.current = items.length;
  }, [items.length]);
  return virtualizer;
}